export const ErrorCode = {
	UnknownError: 'UnknownError',
	ClubSparkErrorCod: 'ClubSparkApiError',
	StripeActionError: 'StripeActionError',
	PaymentMethodCreationError: 'PaymentMethodCreationError',
	FieldValidationError: 'FieldValidationError',
	NetworkError: 'NetworkError'
};
